import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Car, FILE_TYPES } from "../../../../shared/interfaces";
import { DocumentClass } from "../../../../shared/interfaces/enums/document-class-enum";
import { CirculationCardPdfServiceRequest } from "../../../../shared/interfaces/services/circulation-card-pdf-service";
import DocumentsService from "../../../../shared/services/documents";
import { downloadBase64Files, getError } from "../../../../shared/utils";
import { FilenetDocumentRequest } from '../../../../shared/interfaces/services/get-document-service';

export const getCirculationCardPDF = async (circulationCardData: any, possessionFiltered?: any): Promise<string | null> => {
  dayjs.locale('es');

  const filename = circulationCardData?.endorsement?.tarjetaCirculacion;

  const getFromFilenet = async (): Promise<string | null> => {
    const request: FilenetDocumentRequest = {
      documento: {
        nombreDocumento: filename,
        claseDocumental: DocumentClass.ElectronicPolicy,
      },
    };

    try {
      const response = await DocumentsService.getDocumentFromS3(request, false);
      const documento = response?.data?.documento;
      return documento ?? null;
    } catch (error) {
      return null;
    }
  };

  const getOnTheFly = async (): Promise<string | null> => {

    const possessionsToProcess = possessionFiltered
      ? circulationCardData?.possessions?.filter(
        (possession: Car) => possession?.patente === possessionFiltered?.patente
      )
      : circulationCardData?.possessions;

    const possessions = possessionsToProcess?.map((possession: Car) => ({
      numeroPoliza: circulationCardData?.insurancePolicyDetail?.nroPoliza,
      numeroCertificadoPoliza: circulationCardData?.insurancePolicyDetail?.certificado,
      suplementoPoliza: circulationCardData?.endorsement?.nro,
      vigenciaDesde: dayjs(
        possession.fechaIngresoAuto,
        'YYYY-MM-DD',
        true
      ).format('DD/MM/YYYY'),
      vigenciaHasta: Number(possession.endosoDeEgreso) === 0 ? dayjs(circulationCardData?.insurancePolicyDetail?.fechaHastaEndoso).format('DD/MM/YYYY') : dayjs(possession.fechaDeEgreso).format('DD/MM/YYYY'),
      nombreAsegurado: possession?.tarjetaCirculacion,
      cp: circulationCardData?.insuredsByPolicy?.address?.find((item: any) => item.label === 'Código Postal')?.value || '',
      domicilio: circulationCardData?.insuredsByPolicy?.address?.find((item: any) => item.label === 'Domicilio')?.value || '',
      localidad: circulationCardData?.insuredsByPolicy?.address?.find((item: any) => item.label === 'Localidad')?.value || '',
      marca: possession?.marca,
      modelo: possession?.modelo,
      anio: possession?.anio,
      patente: possession?.patente,
      motor: possession?.motor,
      chasis: possession?.chasis,
      tipoDeVehiculo: possession?.tipo,
      tieneAsistencia: possession?.asistenciaTecnica,
      fechaHoyLetra: dayjs().format('DD [de] MMMM [del] YYYY'),
    }));

    const request: CirculationCardPdfServiceRequest = {
      nombrePdf: filename,
      bienes: possessions,
    };

    try {
      const response = await DocumentsService.getCirculationCardPdfOnTheFly(request);
      return response?.data?.base64 ?? null;
    } catch (error) {
      throw new Error(getError(error))
    }
  };

  //   let base64 = await getFromFilenet();

  //  if (!base64) {
  const base64 = await getOnTheFly();
  // }

  if (!base64) {
    throw new Error("No se pudo obtener el documento");
  }

  downloadBase64Files(base64, filename, FILE_TYPES.PDF);
  return base64;
};
